import { ISpacing } from 'styled-components';

export class Spacing implements ISpacing {
  baseValue = 4;
  baseUnit = 'px';
  //all spacing tokens
  spacing1 = `2${this.baseUnit}`; //2px
  spacing2 = `${this.baseValue}${this.baseUnit}`; //4px
  spacing3 = `${this.baseValue * 2}${this.baseUnit}`; //8px
  spacing4 = `${this.baseValue * 3}${this.baseUnit}`; //12px
  spacing5 = `${this.baseValue * 4}${this.baseUnit}`; //16px
  spacing6 = `${this.baseValue * 6}${this.baseUnit}`; //24px
  spacing7 = `${this.baseValue * 8}${this.baseUnit}`; //32px
  spacing8 = `${this.baseValue * 10}${this.baseUnit}`; //40px
  spacing9 = `${this.baseValue * 12}${this.baseUnit}`; //48px
  spacing10 = `${this.baseValue * 16}${this.baseUnit}`; //64px
  spacing11 = `${this.baseValue * 20}${this.baseUnit}`; //80px
  spacing12 = `${this.baseValue * 24}${this.baseUnit}`; //96px
  spacing13 = `${this.baseValue * 40}${this.baseUnit}`; //160px
  defaultPaddingValue = this.baseValue * 2; //12
  roomyContentPaddingValue = this.baseValue * 4; //16
  defaultButtonPadding = `${this.baseValue * 5}${this.baseUnit}`; //20px
}
